(function () {
  var ACCOUNT_ID = 'XH6bmT';
  var KLAVIYO_TRIGGER_CLASS = 'wtpb-bis__klaviyo-hook';
  var state = window.WTPBBackInStock = window.WTPBBackInStock || {};

  function parseVariants(wrapper) {
    try {
      return JSON.parse(wrapper.querySelector('[data-wtpb-bis-variants]').textContent);
    } catch (error) {
      return [];
    }
  }

  function getProductRoot(wrapper) {
    return wrapper.closest('[data-section-type="product"]') ||
      document.querySelector('[data-section-type="product"]');
  }

  function getProductForm(root) {
    return root && (
      root.querySelector('form.ajax-product-form:not([id$="-installments"])') ||
      root.querySelector('form.ajax-product-form') ||
      root.querySelector('form[action*="/cart/add"]')
    );
  }

  function getVariantId(instance) {
    var input = instance.form && instance.form.querySelector('[name="id"]');
    var value = input && input.value;

    if (!value) {
      try {
        value = new URL(window.location.href).searchParams.get('variant');
      } catch (error) {}
    }

    return String(value || instance.wrapper.dataset.initialVariantId || '');
  }

  function variantLabel(variant) {
    if (!variant || !variant.title || variant.title === 'Default Title') {
      return 'this item';
    }
    return variant.title;
  }

  function findKlaviyoTrigger(instance) {
    var trigger = instance.wrapper.querySelector('.' + KLAVIYO_TRIGGER_CLASS) ||
      (instance.root && instance.root.querySelector('.' + KLAVIYO_TRIGGER_CLASS));

    if (!trigger && instance.root) {
      trigger = Array.prototype.find.call(
        instance.root.querySelectorAll('a, button'),
        function (element) {
          return !element.hasAttribute('data-wtpb-bis-primary-trigger') &&
            /notify me when available/i.test(element.textContent || '');
        }
      );
    }

    return trigger || null;
  }

  function setFallbackExpanded(instance, expanded, focusEmail) {
    if (!instance.disclosure) return;
    instance.disclosure.open = expanded;

    if (expanded && focusEmail !== false) {
      var email = instance.fallbackPanel.querySelector('input[type="email"]');
      if (email) window.setTimeout(function () { email.focus(); }, 0);
    }
  }

  function openFallback(instance) {
    setFallbackExpanded(instance, true, true);
  }

  function klaviyoModalIsOpen() {
    var iframe = document.querySelector('#klaviyo-bis-iframe');
    if (!iframe) return false;

    var rect = iframe.getBoundingClientRect();
    var style = window.getComputedStyle(iframe);
    return style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      rect.width > 0 &&
      rect.height > 0;
  }

  function klaviyoIsStable(instance, trigger) {
    var iframe = document.querySelector('#klaviyo-bis-iframe');
    if (!trigger || !iframe) {
      instance.klaviyoReadyAt = null;
      return false;
    }

    if (!instance.klaviyoReadyAt) {
      instance.klaviyoReadyAt = Date.now();
    }
    return Date.now() - instance.klaviyoReadyAt >= 1800;
  }

  function updateFallbackFields(instance, variant) {
    if (!variant) return;

    var label = variantLabel(variant);
    var variantId = String(variant.id || '');
    var title = instance.wrapper.dataset.productTitle || document.title || 'Product';
    var variantNameInput = instance.wrapper.querySelector('[data-wtpb-bis-form-variant-name]');
    var variantIdInput = instance.wrapper.querySelector('[data-wtpb-bis-form-variant-id]');
    var urlInput = instance.wrapper.querySelector('[data-wtpb-bis-form-url]');
    var bodyInput = instance.wrapper.querySelector('[data-wtpb-bis-form-body]');

    if (variantNameInput) variantNameInput.value = label;
    if (variantIdInput) variantIdInput.value = variantId;
    if (urlInput) {
      var productUrl = window.location.origin + window.location.pathname;
      urlInput.value = productUrl + '?variant=' + encodeURIComponent(variantId);
    }
    if (bodyInput) {
      bodyInput.value = 'Back-in-stock request for ' + title + ' — ' + label +
        ' (variant ' + variantId + ').';
    }
  }

  function syncActiveDocumentState() {
    document.documentElement.classList.toggle(
      'wtpb-bis-active',
      Boolean(document.querySelector('[data-wtpb-bis]:not([hidden])'))
    );
  }

  function syncInstance(instance) {
    instance.form = getProductForm(instance.root);
    var id = getVariantId(instance);
    var variant = instance.variants.find(function (candidate) {
      return String(candidate.id) === id;
    });
    var klaviyoTrigger = findKlaviyoTrigger(instance);
    var shouldShow = Boolean(variant && variant.available === false);

    if (klaviyoTrigger) {
      klaviyoTrigger.classList.add(KLAVIYO_TRIGGER_CLASS);
      klaviyoTrigger.setAttribute('aria-hidden', 'true');
      klaviyoTrigger.setAttribute('tabindex', '-1');
      if (klaviyoTrigger.textContent.trim() !== 'Notify me when available') {
        klaviyoTrigger.textContent = 'Notify me when available';
      }

      if (klaviyoTrigger.parentElement !== instance.slot) {
        instance.slot.appendChild(klaviyoTrigger);
      }
    }
    klaviyoIsStable(instance, klaviyoTrigger);

    var nextVariantLabel = variantLabel(variant);
    if (instance.variantName.textContent !== nextVariantLabel) {
      instance.variantName.textContent = nextVariantLabel;
    }
    updateFallbackFields(instance, variant);

    if (instance.wrapper.hidden !== !shouldShow) {
      instance.wrapper.hidden = !shouldShow;
    }
    instance.wrapper.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    if (!shouldShow && !instance.fallbackPanel.querySelector('[role="status"]')) {
      window.clearTimeout(instance.klaviyoWatchdog);
      window.clearTimeout(instance.klaviyoLateWatchdog);
      setFallbackExpanded(instance, false, false);
    }
    syncActiveDocumentState();
  }

  function scheduleSync(instance) {
    window.clearTimeout(instance.timer);
    window.clearTimeout(instance.settleTimer);
    instance.timer = window.setTimeout(function () { syncInstance(instance); }, 40);
    instance.settleTimer = window.setTimeout(function () { syncInstance(instance); }, 250);
  }

  function showAlert(instance) {
    var klaviyoTrigger = findKlaviyoTrigger(instance);
    if (state.klaviyoEnabled && klaviyoTrigger && klaviyoIsStable(instance, klaviyoTrigger)) {
      window.setTimeout(function () {
        klaviyoTrigger.click();

        window.clearTimeout(instance.klaviyoWatchdog);
        window.clearTimeout(instance.klaviyoLateWatchdog);
        instance.klaviyoWatchdog = window.setTimeout(function () {
          if (klaviyoModalIsOpen()) {
            setFallbackExpanded(instance, false, false);
          } else {
            openFallback(instance);
          }
        }, 700);
        instance.klaviyoLateWatchdog = window.setTimeout(function () {
          if (!klaviyoModalIsOpen()) openFallback(instance);
        }, 1400);
      }, 0);
      return;
    }
    window.setTimeout(function () { openFallback(instance); }, 0);
  }

  function instanceForWrapper(wrapper) {
    return (state.instances || []).find(function (instance) {
      return instance.wrapper === wrapper;
    }) || null;
  }

  function handlePrimaryTriggerClick(event) {
    var primaryTrigger = event.target.closest &&
      event.target.closest('[data-wtpb-bis-primary-trigger]');
    if (!primaryTrigger) return;

    var wrapper = primaryTrigger.closest('[data-wtpb-bis]');
    if (!wrapper) return;

    state.instances = (state.instances || []).filter(function (candidate) {
      return candidate.wrapper && candidate.wrapper.isConnected;
    });
    var instance = instanceForWrapper(wrapper) || mount(wrapper);
    if (!instance) return;

    instance.primaryTrigger = primaryTrigger;
    instance.fallbackPanel = wrapper.querySelector('[data-wtpb-bis-fallback-panel]');
    instance.disclosure = wrapper.querySelector('[data-wtpb-bis-disclosure]');
    instance.slot = wrapper.querySelector('[data-wtpb-bis-slot]');
    if (!instance.fallbackPanel || !instance.disclosure || !instance.slot) return;
    if (instance.disclosure.open) return;
    showAlert(instance);
  }

  function mount(wrapper) {
    if (!wrapper) return null;
    var existingInstance = instanceForWrapper(wrapper);
    if (existingInstance) return existingInstance;

    var root = getProductRoot(wrapper);
    var variantName = wrapper.querySelector('[data-wtpb-bis-variant-name]');
    var slot = wrapper.querySelector('[data-wtpb-bis-slot]');
    var description = wrapper.querySelector('[id^="wtpb-bis-description-"]');
    var primaryTrigger = wrapper.querySelector('[data-wtpb-bis-primary-trigger]');
    var fallbackPanel = wrapper.querySelector('[data-wtpb-bis-fallback-panel]');
    var disclosure = wrapper.querySelector('[data-wtpb-bis-disclosure]');
    if (!root || !variantName || !slot || !description || !primaryTrigger || !fallbackPanel || !disclosure) return;

    wrapper.dataset.wtpbBisReady = 'true';
    var instance = {
      wrapper: wrapper,
      root: root,
      form: getProductForm(root),
      variants: parseVariants(wrapper),
      variantName: variantName,
      slot: slot,
      descriptionId: description.id,
      primaryTrigger: primaryTrigger,
      fallbackPanel: fallbackPanel,
      disclosure: disclosure,
      timer: null,
      settleTimer: null,
      klaviyoWatchdog: null,
      klaviyoLateWatchdog: null,
      klaviyoReadyAt: null
    };

    state.instances.push(instance);

    root.addEventListener('change', function () { scheduleSync(instance); });
    root.addEventListener('click', function (event) {
      if (event.target.closest('.option-selector__btns, [data-option-selector], .sls-option-container')) {
        scheduleSync(instance);
      }
    });

    ['variant:change', 'product:variant-change', 'shopify:variant:change'].forEach(function (eventName) {
      root.addEventListener(eventName, function () { scheduleSync(instance); });
    });

    if (window.MutationObserver) {
      instance.observer = new MutationObserver(function () { scheduleSync(instance); });
      instance.observer.observe(root, {
        childList: true,
        subtree: true
      });
    }

    syncInstance(instance);
    return instance;
  }

  function mountAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-wtpb-bis]'), mount);
  }

  function enableKlaviyo() {
    if (state.klaviyoEnabled) return true;

    var klaviyo = window.klaviyo = window.klaviyo || [];
    if (typeof klaviyo.init !== 'function' || typeof klaviyo.enable !== 'function') return false;

    klaviyo.init({
      account: ACCOUNT_ID,
      platform: 'shopify'
    });

    klaviyo.enable('backinstock', {
      trigger: {
        product_page_text: 'Notify me when available',
        product_page_class: KLAVIYO_TRIGGER_CLASS,
        product_page_text_align: 'center',
        product_page_margin: '0px',
        replace_anchor: false
      },
      modal: {
        headline: '{product_name}',
        body_content: 'Choose the option you want, then enter your email. We will send one message as soon as it is restocked.',
        email_field_label: 'Email address',
        button_label: 'Notify me when available',
        subscription_success_label: 'You are on the list for this option. We will send one restock alert; inventory is first come, first served.',
        footer_content: 'Need it sooner? Call Christopher for an in-stock alternative: 800-670-1754.',
        font_family: 'Arial, Helvetica, sans-serif',
        additional_styles: '',
        drop_background_color: '#28180f',
        background_color: '#fbf7ef',
        text_color: '#2f241b',
        button_text_color: '#fffaf2',
        button_background_color: '#4f2e16',
        close_button_color: '#8a5a20',
        error_background_color: '#f7dfda',
        error_text_color: '#8a2f24',
        success_background_color: '#f2eadc',
        success_text_color: '#2f241b'
      }
    });

    state.klaviyoEnabled = true;
    state.instances.forEach(scheduleSync);
    return true;
  }

  function start() {
    state.instances = (state.instances || []).filter(function (instance) {
      return instance.wrapper && instance.wrapper.isConnected;
    });
    mountAll(document);

    if (!enableKlaviyo()) {
      var attempts = 0;
      state.klaviyoTimer = window.setInterval(function () {
        attempts += 1;
        if (enableKlaviyo() || attempts >= 40) {
          window.clearInterval(state.klaviyoTimer);
        }
      }, 250);
    }
  }

  if (!state.delegatedClickBound) {
    document.addEventListener('click', handlePrimaryTriggerClick, true);
    state.delegatedClickBound = true;
  }

  if (!state.started) {
    state.started = true;
    start();

    document.addEventListener('shopify:section:load', function (event) {
      mountAll(event.target);
      state.instances.forEach(scheduleSync);
    });

    window.addEventListener('popstate', function () {
      state.instances.forEach(scheduleSync);
    });
  } else {
    mountAll(document);
    state.instances.forEach(scheduleSync);
  }
}());
